import React, { } from 'react';
import { Grid, GridItem } from '@chakra-ui/react';
import { SPACING } from '../../generic/config';
import { customerName } from '../../generic/customerName';
import { Context } from '../../App';
import { Customer, CustomerModel } from '../../model/customer';
import ModelInput from '../../base-components/ModelInput';
import Card from '../../base-components/Card';
import useModel from '../../base-components/hooks/useModel';
import EditorParent from '@/base-components/EditorParent';
import CustomerWorksites from './CustomerWorksites';
import AttachedFilesGridItem from '../order/AttachedFilesGridItem';
import { isDesktop } from 'react-device-detect';
import { previewAttachmentFromCustomer } from '@/api/customer-controller';
import PropertyValuesCard from '@/base-components/PropertyValuesCard';

const CustomerPage: React.FC = () => {
    const { translations } = React.useContext(Context);
    const { model, toolbar } = useModel<Customer>(CustomerModel);
    const title = customerName(model.object) + " (" + model.object.id + ")";
    const identificationNumberTitle = model.object.isCompany ? translations.model.customer.identificationNumber.organizationNumber : translations.model.customer.identificationNumber.ssn;

    return (
        <EditorParent title={title} description={model.object.identificationNumber + " (" + model.object.externalId + ")"} toolbar={toolbar}>
            <Grid templateColumns={isDesktop ? "repeat(2, 1fr)" : "repeat(1, 1fr)"} gap={SPACING}>
                <GridItem>
                    <Card {...translations.model.customer.cards.baseInfo} height={"100%"}>
                        <ModelInput title={translations.model.customer.isCompany} fieldKey="isCompany" model={model} />

                        {!model.object.isCompany && (
                            <>
                                <ModelInput title={translations.model.customer.firstName} fieldKey="firstName" model={model} />
                                <ModelInput title={translations.model.customer.lastName} fieldKey="lastName" model={model} />
                            </>
                        )}

                        {model.object.isCompany && (
                            <>
                                <ModelInput title={translations.model.customer.companyName} fieldKey="firstName" model={model} />
                                <ModelInput title={translations.model.customer.lastName} fieldKey="lastName" model={model} />
                            </>
                        )}
                    </Card>
                </GridItem>
                <GridItem>
                    <Card {...translations.model.customer.cards.identificationInfo} height={"100%"}>
                        <ModelInput title={translations.model.customer.externalId} fieldKey="externalId" model={model} />
                        <ModelInput title={identificationNumberTitle} fieldKey="identificationNumber" model={model} />
                        <ModelInput title={translations.model.customer.vatNumber} fieldKey="vatNumber" model={model} />
                    </Card>
                </GridItem>
                <GridItem>
                    <Card {...translations.model.customer.cards.contactInfo} height={"100%"}>
                        <ModelInput title={translations.model.customer.primaryContact} fieldKey="primaryContact" model={model} />
                        <ModelInput title={translations.model.customer.email} fieldKey="email" model={model} />
                        <ModelInput title={translations.model.customer.phone} fieldKey="phone" model={model} />
                    </Card>
                </GridItem>
                <GridItem>
                    <Card {...translations.model.customer.cards.addressInfo} height={"100%"}>
                        <ModelInput title={translations.model.customer.address} fieldKey="address" model={model} />
                        <ModelInput title={translations.model.customer.postalCode} fieldKey="postalCode" model={model} />
                        <ModelInput title={translations.model.customer.city} fieldKey="city" model={model} />
                    </Card>
                </GridItem>
                <GridItem colSpan={isDesktop ? 2 : 1}>
                    <Card {...translations.model.customer.cards.notes}>
                        <ModelInput title={translations.model.customer.notes} fieldKey="notes" model={model} />
                    </Card>
                </GridItem>
                <GridItem colSpan={isDesktop ? 2 : 1}>
                    <CustomerWorksites model={model} />
                </GridItem>
                <GridItem>
                    <PropertyValuesCard
                        objectType="customer"
                        objectId={model.object.id}
                        values={model.object.propertyValues}
                        onChange={(propertyValues) => model.setObject({ ...model.object, propertyValues })}
                    />
                </GridItem>
                <AttachedFilesGridItem model={model} previewAttachment={previewAttachmentFromCustomer} />
            </Grid>
        </EditorParent>
    );
};

export default CustomerPage;